// Spec: .github/specs/7740058-auth0-protected-api-allowlist.md
import { HttpRequest } from '@angular/common/http';
import {
  auth0ProtectedPrefixes,
  auth0PublicEndpoints,
} from '../constants/endpoints';

/**
 * Determines token eligibility using the request origin, path and method only.
 * @param req Outbound HTTP request.
 * @param origin Application origin, including scheme and port.
 * @returns Whether the request requires Auth0 authorization.
 */
export function isAuth0ProtectedRequest(
  req: HttpRequest<unknown>,
  origin: string,
): boolean {
  let url: URL;
  let appOrigin: URL;
  try {
    appOrigin = new URL(origin);
    url = new URL(req.url, appOrigin.origin);
  } catch {
    return false;
  }

  if (
    !['http:', 'https:'].includes(appOrigin.protocol) ||
    url.origin !== appOrigin.origin
  ) {
    return false;
  }

  const pathname = url.pathname.toLowerCase();
  let pathEnd = pathname.length;
  while (pathEnd > 0 && pathname[pathEnd - 1] === '/') {
    pathEnd--;
  }
  const path = pathname.slice(0, pathEnd);
  if (
    !auth0ProtectedPrefixes.some(
      (prefix) => path === prefix || path.startsWith(`${prefix}/`),
    )
  ) {
    return false;
  }

  if (/%(?:2f|5c|25)|%(?![0-9a-f]{2})/i.test(path)) {
    return true;
  }

  const segments = path.split('/');
  return !auth0PublicEndpoints.some((endpoint) => {
    const publicSegments = endpoint.path.split('/');
    return (
      endpoint.methods.includes(req.method.toUpperCase()) &&
      segments.length === publicSegments.length &&
      publicSegments.every((segment, index) =>
        segment.startsWith(':')
          ? segments[index].length > 0
          : segment === segments[index],
      )
    );
  });
}
